import { Card, CardMedia } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from "../../common/theme";

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    border: `2px solid ${colors.primaryGold}`,
  },
  media: {
    height: '100%',
  },
});

const AboutUsImage2 = ({ img, position }) => {
  const classes = useStyles();
  return (
    <div style={{ height: '100%', minHeight: '250px' }}>
      <Card elevation={5} className={classes.root}>
        <CardMedia
          style={{ backgroundPosition: position || 'center' }}
          className={classes.media}
          image={img}
        />
      </Card>
    </div>
  );
};

export default AboutUsImage2;
